// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"10ca8912","336":"fbde3ef5"}[chunkId] + ".chunk.js";
};